import React from 'react';
import Icon from '../../../components/AppIcon';

const PromptQualityIndicator = ({ score, feedback }) => {
  const getQualityLevel = () => {
    if (score >= 80) return { label: 'Excellent', color: 'text-success', bgColor: 'bg-success/10', icon: 'CheckCircle2' };
    if (score >= 60) return { label: 'Good', color: 'text-accent', bgColor: 'bg-accent/10', icon: 'ThumbsUp' };
    if (score >= 40) return { label: 'Fair', color: 'text-warning', bgColor: 'bg-warning/10', icon: 'AlertCircle' };
    return { label: 'Needs Improvement', color: 'text-error', bgColor: 'bg-error/10', icon: 'AlertTriangle' };
  };

  const quality = getQualityLevel();

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className={`w-8 h-8 rounded-full ${quality?.bgColor} flex items-center justify-center`}>
            <Icon name={quality?.icon} size={16} className={quality?.color} />
          </div>
          <div>
            <p className="text-xs text-muted-foreground">Prompt Quality</p>
            <p className={`text-sm font-semibold ${quality?.color}`}>{quality?.label}</p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-2xl font-bold">{score}%</p>
        </div>
      </div>
      <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
        <div
          className={`h-full transition-all duration-500 ${
            score >= 80 ? 'bg-success' : score >= 60 ? 'bg-accent' : score >= 40 ? 'bg-warning' : 'bg-error'
          }`}
          style={{ width: `${score}%` }}
        />
      </div>
      {feedback && (
        <p className="text-xs md:text-sm text-muted-foreground mt-3">{feedback}</p>
      )}
    </div>
  );
};

export default PromptQualityIndicator;